import { path, pipe } from 'ramda';
import { cashOptions } from '../../../../common/helpers/cash';

export const getChargeAmount = path(['register', 'payment', 'chargeAmount']);

export const getCashOptions = pipe(
  getChargeAmount,
  cashOptions,
);
